<template>
	<!-- 关于云锦 -->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/myicon/left01.png" alt="">
					</div>
					<p class="header_titile">阅读页设置</p>
				</div>
			</div>
		</van-sticky>
		<div class="setType">
			<div class="xtszListItem">
				<span>音量键翻页</span>
				<div>
					<van-switch v-model="yljfy" size="20px" active-color="#07c160" inactive-color="#ffffff" />
				</div>
			</div>
			<div class="xtszListItem">
				<span>自动下载</span>
				<div>
					<van-switch v-model="downFn" size="20px" active-color="#07c160" inactive-color="#ffffff" />
				</div>
			</div>
			<div class="set_txt">
				<span>翻页模式</span>
				<!-- <span @click="mode2Fn"></span><span @click="mode1Fn" :class=""></span><span></span> -->
				<span v-for="(itm,idx) in listState" @click="mode1Fn(idx)" :class="activeIdx == idx ? 'active' : ''">{{itm}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {Toast} from 'vant'
	export default {
		data() {
			return {
				yljfy:true,
				downFn: false,
				activeIdx: 0,
				listState:['无','拖动','上下']
			}
		},
		created() {
			var transitionDuration = localStorage.getItem('transitionDuration') || '0s';
			if(transitionDuration == '0s'){
				this.activeIdx = 0;
			}else if(transitionDuration == '0.5s'){
				this.activeIdx = 1;
			}
		},
		methods: {
			mode1Fn(idx){
				this.activeIdx = idx;
				if(idx == 0){
					localStorage.setItem('transitionDuration','0s')
				}else if(idx == 1){
					localStorage.setItem('transitionDuration','0.5s')
				}else if(idx == 2){
					Toast('暂未开通')
				}
			},
			// mode1Fn(){
			// 	localStorage.setItem('transitionDuration','0.5s')
			// 	this.$router.push('/readbook')
			// 	this.$router.push({path: '/readbook', query: {transitionDuration: '0.5s',readId:this.$route.query.readId,id: this.$route.query.id,pageurl:this.$route.query.pageurl}});
			// },
			// mode2Fn(){
				// localStorage.setItem('transitionDuration','0s')
				// this.$router.push('/readbook')
				// this.$router.push({path: '/readbook', query: {transitionDuration: '0s',readId:this.$route.query.readId,id: this.$route.query.id,pageurl:this.$route.query.pageurl}});
			// }
		}
	}
</script>

<style lang="less" scoped>
	.aboutYjBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #fff;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 60px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		.setType{
			padding: 0 16px;
			.xtszListItem{
				border-bottom: 1px solid #f0f0f0;/*no*/
				display: flex;
				line-height: 90px;
				span,div{
					flex:1;
					font-size: 30px;/*px*/
				}
				>div{
					text-align: right;
					position: relative;
					.van-switch{
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
						}
				}
			}
			.set_txt{
				line-height: 80px;
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				span{
					padding-right: 50px;
					font-size: 30px;/*px*/
				}
				.active{
					color: #ff4081;
				}
			}
			.setTypeItem {
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				height: 90px;
				line-height: 90px;
				display: flex;
				position: relative;
			
				.setTypeLeft {
					flex: 1;
					font-size: 30px;
					/*px*/
					color: #000000;
				}
			
				.setTypeRight {
					height: 84px;
			
					img {
						height: 60px;
						position: absolute;
						top: 50%;
						right: -10px;
						transform: translateY(-50%);
					}
				}
			}
		}
	}

</style>
